import { gql } from '@apollo/client';

import { StudentActivity } from '@ts-core/modules/activities/types';
import { studentActivityFragment } from '../fragments';

export interface CreateActivityAnswerMutationVariables {
  courseId: string;
  activityId: string;
  input: {
    text?: string;
    file?: {
      name: string;
      path: string;
    };
  };
}

export interface CreateActivityAnswerMutationResult {
  activity: StudentActivity;
}

export const createActivityAnswerMutation = gql`
  mutation CreateActivityAnswer($courseId: String!, $activityId: String!, $input: CreateActivityAnswerInput!) {
    activity(courseId: $courseId, activityId: $activityId, input: $input)
      @rest(type: "Activity", path: "courses/{args.courseId}/activities/{args.activityId}/answers", method: "POST") {
      ...StudentActivity
    }
  }
  ${studentActivityFragment}
`;
